import auth from './auth';

export default {
  modules: {
    auth,
  },
};
